/**
 * This component acts as a switch for the send/success route. Since we're mashing
 * gifting into the send flow (in addition to its own /gift flow), if someone chooses a gift
 * during /send then the success page should be the gift-success. Otherwise just
 * be the normal send-success.
 */
import PropTypes from 'prop-types'

import React from 'react'
import { connect } from 'transfer/utils/p2p-connect'
import GiftSuccess from './gift-success'
import OutlookSuccess from './outlook-success'
import SendSuccess from './send-success'
import { withRouter } from 'react-router-dom'
import * as ViewActions from '../actions/Actions'
import DCSendMoneyRequestSuccess from './dcSendMoneyRequestSuccess'
import _ from 'lodash'

class SendSuccessWrapper extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    hasSentGift: PropTypes.bool.isRequired,
    isOutlookFlow: PropTypes.bool.isRequired,
    isDCSendMoneyRequest: PropTypes.bool.isRequired,
    unified: PropTypes.bool,
  }

  componentWillUnmount() {
    this.props.dispatch(ViewActions.leavingSuccessPage())
  }

  render() {
    if (this.props.hasSentGift) {
      return <GiftSuccess unified={!!this.props.unified} />
    }

    if (this.props.isOutlookFlow) {
      return <OutlookSuccess />
    }

    if (this.props.isDCSendMoneyRequest) {
      return <DCSendMoneyRequestSuccess />
    }

    return <SendSuccess unified={!!this.props.unified} />
  }
}

export default withRouter(
  connect(({ theme, server }) => ({
    hasSentGift: !!theme.themeId,
    isOutlookFlow: server.env === 'outlook',
    isDCSendMoneyRequest: _.get(
      server,
      'businessAccountInfo.isDCSendMoneyRequest',
      false
    ),
  }))(SendSuccessWrapper)
)
